import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Power, GitBranch } from "lucide-react";

// The "railroad switch": master on/off for all AI generation + a model re-route.
export function AiSwitch() {
  const [c, setC] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/ai/studio/ai-controls").then((r) => setC(r.data)).catch(() => setC(null));
  useEffect(() => { load(); }, []);

  const save = async (patch) => {
    setBusy(true);
    try {
      const { data } = await api.put("/ai/studio/ai-controls", patch);
      setC((p) => ({ ...p, ...data }));
      toast.success(patch.enabled === false ? "AI generation paused" : patch.enabled === true ? "AI generation resumed" : "AI model updated");
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };

  if (!c) return null;
  const on = c.enabled;

  return (
    <div className={`flex items-center gap-3 flex-wrap text-xs px-3 py-2 mb-4 border ${on ? "border-white/10 bg-navy-800" : "border-red-500/40 bg-red-500/10"}`} data-testid="ai-switch">
      <button
        data-testid="ai-switch-toggle"
        onClick={() => save({ enabled: !on })}
        disabled={busy}
        className={`inline-flex items-center gap-2 px-3 py-1.5 font-semibold transition-colors ${on ? "bg-emerald-500/15 text-emerald-300 border border-emerald-500/40 hover:bg-emerald-500/25" : "bg-red-500/20 text-red-300 border border-red-500/50 hover:bg-red-500/30"}`}>
        <Power size={14} /> {on ? "AI is ON" : "AI is PAUSED"}
      </button>
      {!on && <span className="text-red-300">All AI generation is stopped until you switch it back on.</span>}
      <div className="flex items-center gap-2 ml-auto">
        <GitBranch size={14} className="text-gold" />
        <span className="text-gray-400">Model track:</span>
        <select
          data-testid="ai-switch-model"
          value={c.model_override || ""}
          onChange={(e) => save({ model_override: e.target.value })}
          disabled={busy}
          className="bg-navy border border-white/20 text-white px-2 py-1 focus:border-gold focus:outline-none">
          <option value="">Auto (default routing)</option>
          {(c.models || []).map((m) => <option key={m.id} value={m.id}>{m.label}</option>)}
        </select>
      </div>
    </div>
  );
}

export default AiSwitch;
